import React, { useState } from 'react';
import { SearchIcon, XIcon } from 'lucide-react';
import { Header } from '../components/Header';
import { CategoryChips } from '../components/CategoryChips';
import { ProductCard } from '../components/ProductCard';
import { mockProducts, categories } from '../data/mockData';
import { Product, CartItem } from '../types';
interface HomeProps {
  cart: CartItem[];
  onAddToCart: (product: Product) => void;
  onSwapProduct: (currentProduct: Product, alternativeId: string) => void;
  onNavigateToCart: () => void;
  onNavigateToProfile: () => void;
}
export function Home({
  cart,
  onAddToCart,
  onSwapProduct,
  onNavigateToCart,
  onNavigateToProfile
}: HomeProps) {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');
  const filteredProducts = mockProducts.filter(product => {
    const matchesCategory = selectedCategory === 'All' || product.category === selectedCategory;
    const matchesSearch = searchQuery === '' || product.name.toLowerCase().includes(searchQuery.toLowerCase()) || product.category.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });
  const cartCount = cart.reduce((sum, item) => sum + item.quantity, 0);
  return <div className="min-h-screen bg-gray-50 pb-24" data-id="element-238">
      <Header cartCount={cartCount} onCartClick={onNavigateToCart} onProfileClick={onNavigateToProfile} data-id="element-239" />

      <CategoryChips categories={categories} selected={selectedCategory} onSelect={setSelectedCategory} data-id="element-240" />

      <main className="max-w-lg mx-auto px-4 py-6" data-id="element-241">
        <div className="mb-4" data-id="element-242">
          <div className="relative mb-3" data-id="element-243">
            <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-244" />
            <input type="text" placeholder="Search products..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-10 py-3 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" data-id="element-245" />
            {searchQuery && <button onClick={() => setSearchQuery('')} className="absolute right-3 top-1/2 -translate-y-1/2 p-1 hover:bg-gray-100 rounded-full transition-colors" aria-label="Clear search" data-id="element-246">
                <XIcon className="w-4 h-4 text-gray-400" data-id="element-247" />
              </button>}
          </div>

          <h1 className="text-2xl font-bold text-gray-900" data-id="element-248">
            {searchQuery ? 'Search Results' : selectedCategory === 'All' ? 'Shop Groceries' : selectedCategory}
          </h1>
        </div>

        <div className="grid grid-cols-1 gap-4" data-id="element-249">
          {filteredProducts.map(product => <ProductCard key={product.id} product={product} onAdd={onAddToCart} onSwap={onSwapProduct} allProducts={mockProducts} data-id="element-250" />)}
        </div>

        {filteredProducts.length === 0 && <div className="text-center py-12" data-id="element-251">
            <p className="text-gray-500 mb-2" data-id="element-252">
              {searchQuery ? `No products found for "${searchQuery}"` : 'No products found in this category.'}
            </p>
            {searchQuery && <button onClick={() => setSearchQuery('')} className="text-green-600 hover:text-green-700 font-medium" data-id="element-253">
                Clear search
              </button>}
          </div>}
      </main>
    </div>;
}